import { useTypedMutation } from 'sierra-client/state/api'
import { XAnalyticsGenerateFilter } from 'sierra-domain/routes'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useGenerateAiFilter = () => {
  return useTypedMutation(XAnalyticsGenerateFilter, {})
}
